import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipoDocumentiEditModalComponent.vue?vue&type=template&id=6a45526e"
import script from "./ConfigurazioneContabilitaTipoDocumentiEditModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipoDocumentiEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports